import { Pressable, Text } from 'react-native';
import theme from '../../theme';

const SIZES = {
  sm: { paddingVertical: 6, paddingHorizontal: 12, fontSize: theme.typography.size.xs, height: 30 },
  md: { paddingVertical: 8, paddingHorizontal: 14, fontSize: theme.typography.size.sm, height: 36 },
  lg: { paddingVertical: 10, paddingHorizontal: 18, fontSize: theme.typography.size.base, height: 42 },
};

const VARIANTS = {
  primary: { bg: theme.colors.accentPrimary, bgHover: theme.colors.accentPrimaryHover, fg: theme.colors.accentOnPrimary, border: theme.colors.accentPrimary },
  secondary: { bg: theme.colors.surfaceCard, bgHover: theme.colors.surfaceSunken, fg: theme.colors.textPrimary, border: theme.colors.borderDefault },
  critical: { bg: theme.colors.accentCritical, bgHover: theme.colors.accentCriticalHover, fg: '#fff', border: theme.colors.accentCritical },
};

const Button = ({ children, onPress, variant = 'primary', size = 'lg', style }) => {
  const v = VARIANTS[variant];
  const s = SIZES[size];

  return (
    <Pressable onPress={onPress} style={style}>
      {({ pressed, hovered }) => (
        <Text
          style={{
            backgroundColor: pressed || hovered ? v.bgHover : v.bg,
            color: v.fg,
            borderWidth: 1,
            borderColor: v.border,
            borderRadius: theme.radii.md,
            fontFamily: theme.typography.fontSans,
            fontWeight: theme.typography.weight.medium,
            fontSize: s.fontSize,
            paddingVertical: s.paddingVertical,
            paddingHorizontal: s.paddingHorizontal,
            textAlign: 'center',
            overflow: 'hidden',
          }}
        >
          {children}
        </Text>
      )}
    </Pressable>
  );
};

export default Button;